import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'audioConfigType';

export class ChannelConfigType extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
